import { render, staticRenderFns } from "./Item01.vue?vue&type=template&id=caabfe02&scoped=true&"
import script from "./Item01.vue?vue&type=script&lang=js&"
export * from "./Item01.vue?vue&type=script&lang=js&"
import style0 from "./Item01.vue?vue&type=style&index=0&id=caabfe02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caabfe02",
  null
  
)

export default component.exports